import { render, staticRenderFns } from "./ResultHeading.vue?vue&type=template&id=5d0cf8b1&"
import script from "./ResultHeading.vue?vue&type=script&lang=js&"
export * from "./ResultHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports